module.exports = __webpack_public_path__ + "img/IT0000102866722.18f5e10d.png";